import Reveal from '@/components/base/Reveal';
import SectionTitle from '@/components/base/SectionTitle';
import { highlights } from '@/mocks/drama';

export default function HighlightSection() {
  return (
    <section id="highlights" className="bg-foreground-950 py-14 md:py-20">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <Reveal>
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-2 font-label text-xs tracking-[0.2em] text-accent-300 uppercase">
              <span className="h-px w-6 bg-accent-400" />
              精彩名场面
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-background-50 leading-snug">
              讨论度最高的几场戏，值得单独回看
            </h2>
            <p className="mt-3 md:mt-4 font-body text-sm md:text-base leading-relaxed text-background-300">
              名场面之所以好看，往往不只是台词爽，而是把前面埋了很久的伏笔一次性收拢。下面这几段，是观众提到最多、也最容易被反复回看的段落。
            </p>
          </div>
        </Reveal>

        <div className="mt-10 grid gap-5 md:gap-6 grid-cols-1 md:grid-cols-2">
          {highlights.map((item, index) => (
            <Reveal key={item.id} delay={index * 60}>
              <article className="group h-full overflow-hidden rounded-lg border border-foreground-800 bg-foreground-900">
                <div className="h-48 md:h-56 w-full overflow-hidden">
                  <img
                    src={item.image}
                    alt={`《漂亮的小姨子》${item.time}「${item.title}」场景画面`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-5">
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500/15 px-3 py-1 font-label text-xs text-accent-300">
                    <i className="ri-bookmark-2-line" aria-hidden="true" />
                    {item.time}
                  </span>
                  <h3 className="mt-3 font-heading text-lg font-bold text-background-50">{item.title}</h3>
                  <p className="mt-2 font-body text-sm leading-relaxed text-background-300">{item.desc}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}